import { FieldData, TextField, useForm } from 'vopay';
import { useTranslation } from 'react-i18next';
import { InvoicesSearchParams } from '../types';

export type UseInvoicesSearchFormConfigParams = {
  /** The keyword currently in the URL. Re-seeded on change, so Back and a cleared filter both stick. */
  initialValues: InvoicesSearchParams;
  onSubmit: (searchParams: InvoicesSearchParams) => void;
};

export default function useInvoicesSearchFormConfig({ initialValues, onSubmit }: UseInvoicesSearchFormConfigParams) {
  const config = useConfig();

  const { renderFormElements, ctx } = useForm<InvoicesSearchParams>({
    initialValues,
    config,
    onSubmit,
    // The parent feeds this from the URL, which changes without a remount (browser Back).
    enableReinitialize: true,
  });

  return {
    ctx,
    renderFormElements: () => renderFormElements({ config }),
  };
}

function useConfig(): FieldData<InvoicesSearchParams>[] {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Placeholders' });

  return [
    {
      fieldName: 'searchTerm',
      getInputState: () => 'optional',
      showField: () => true,
      renderField: ({ getFormikData }) => (
        <TextField
          variant="outlineShadow"
          {...getFormikData<InvoicesSearchParams['searchTerm']>({})}
          placeholder={t('keyword', { defaultValue: 'Keyword' })}
        />
      ),
    },
  ];
}
